import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axiosInstance from "../axios.config";
import { CoursesTableWrapper } from "../components/Courses/CoursesTable";
import UpdateCourseDialog from "../components/Courses/UpdateCourseModal";
import { AddCourseModal } from "../components/Courses/AddCourseModal";
import { ContentBlock } from "../shared/sharedStyles";
import { Box, styled, Typography } from "@mui/material";
import { FilteringBlock } from "../components/Courses/FilteringBlock";
import { CourseChartModal } from "../components/Courses/CourseChartModal";
import 'react-toastify/dist/ReactToastify.css';

const InnerContent = styled(ContentBlock)(({ theme }) => ({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },

    '& p': {
        margin: 0,
    },
}));

const Courses = () => {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const lngsltd = JSON.parse(localStorage.getItem('languageSelected'));
    const userRole = userDetails.role;
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showadd, setShowAdd] = useState(false);
    const handleCloseAdd = () => {
        setShowAdd(false);
        clear();
        clearErrors();
    }
    const handleShowAdd = () => setShowAdd(true);

    //For filters option
    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState('');

    //For Adding new Course
    const [coursename, setCourseName] = useState('')
    const [coursedes, setCourseDes] = useState('')

    //For Updating existing Course
    const [editID, setEditId] = useState('')
    const [editCourseName, setEditCourseName] = useState('')
    const [editCourseDes, setEditCourseDes] = useState('')
    const [editGrpName, setEditGrpName] = useState('')

    //For binding Group as a dropdown list
    const [groupID, setGroupID] = useState('');

    //For updating group from the dropdown list
    const [editGroupID, setEditGroupID] = useState('');

    const [data, setData] = useState(null);
    const [grpName, setGrpName] = useState('');
    const [groupData, setGroupData] = useState([]);

    //Validation Variable
    const [courseNameError, setCourseNameError] = useState('');
    const [grpNameError, setGrpNameError] = useState('');
    const buttonRef = useRef(null);
    const [editGrpNameError, setEditGrpNameError] = useState('');
    const [editCourseNameError, setEditCourseNameError] = useState('');
    const [courseIdForChart, setCourseIdForChart] = useState(null);

    useEffect(() => {
        getData();
        fetchGroupData();
    }, []);

    useEffect(() => {
        if (data && Array.isArray(data) && data?.length !== 0) {
            const filteredUsers = data?.filter(user => {
                const coursenameMatch = user.courseName.toLowerCase().includes(search.toLowerCase());
                return coursenameMatch;
            });
            setFilteredData(filteredUsers || []);
        }
    }, [search, data]);

    const getData = () => {
        const userDetails = JSON.parse(localStorage.getItem('userDetails'));
        const userRole = userDetails.role;
        if (userRole === 'Admin') {
            axiosInstance.get(`/Course`)
                .then((result) => {
                    setData(result.data);
                })
        } else {
            axiosInstance.get(`/Course/GetCoursesForUser/${userDetails.userID}`)
                .then((result) => {
                    setData(result.data);
                })
        }
        clear();
    }

    const fetchGroupData = () => {
        axiosInstance.get(`/Group`)
            .then((result) => {
                setGroupData(result.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    };

    const handleEdit = (id) => {
        handleShow();
        axiosInstance.get(`/Course/${id}`)
            .then((result) => {
                setEditCourseName(result.data.courseName);
                setEditCourseDes(result.data.description);
                setEditGrpName(result.data.groupName);
                setEditGroupID(result.data.groupID);
                setEditId(id);
            })
            .catch((error) => {
                // console.log(error);
            })
    }

    const handleDelete = (id) => {
        if (window.confirm(lngsltd["Are you sure to delete this Course?"]) === true) {
            axiosInstance.delete(`/Course/${id}`)
                .then((result) => {
                    toast.success(lngsltd['Course has been deleted']);
                    getData();
                })
                .catch((error) => {
                    toast.error(error);
                })
        }
    }

    const handleDetails = (id) => {
        navigate(`/courses/${id}`);
    }

    const handleReport = (id) => {
        navigate(`/coursereport/${id}`);
    }

    const handleStart = async (id) => {
        try {
            navigate(`/startcoursepage/${id}`);
        } catch (error) {
        }
    };

    const handleUpdate = () => {
        let formIsValid = true;

        if (!editCourseName) {
            setEditCourseNameError('Name is required');
            formIsValid = false;
        } else {
            setEditCourseNameError('');
        }

        if (!editGrpName) {
            setEditGrpNameError('');
            formIsValid = false;
        } else {
            setEditGrpNameError('');
        }
        if (formIsValid) {
            const url = `/Course/${editID}`;
            const data = {
                "courseID": editID,
                "courseName": editCourseName,
                "description": editCourseDes,
                "groupName": editGrpName
            }

            axiosInstance.put(url, data)
                .then((result) => {
                    handleClose();
                    getData();
                    clear();
                    toast.success(lngsltd['Course has been updated']);
                }).catch((error) => {
                    toast.error(error);
                })
        }
    }

    const handleSave = () => {
        let formIsValid = true;

        if (!coursename) {
            setCourseNameError('CourseName is required');
            formIsValid = false;
        } else {
            setCourseNameError('');
        }
        if (!grpName) {
            setGrpNameError('GroupName is required');
            formIsValid = false;
        } else {
            setGrpNameError('');
        }


        if (formIsValid) {
            const url = `/Course`;
            const data = {
                "courseID": 0,
                "courseName": coursename,
                "description": coursedes,
                "groupName": grpName
            }
            axiosInstance.post(url, data)
                .then((result) => {
                    handleCloseAdd();
                    getData();
                    clear();
                    toast.success(result.data);
                }).catch((error) => {
                    toast.error(error);
                })
        }
    }

    const handleClearFilters = () => {
        setSearch('');
    }

    const validateCourseName = (value) => {
        if (!value.trim()) {
            return lngsltd['Coursename is required'];
        }
        return '';
    };

    const handleCourseNameChange = (e) => {
        const value = e.target.value;
        const errorMessage = validateCourseName(value);
        setCourseNameError(errorMessage);
        setCourseName(value);
    };

    const clearErrors = () => {
        setCourseNameError('');
        setGrpNameError('');
        setEditGrpNameError('');
        setEditCourseNameError('');
    };


    const clear = () => {
        setCourseName('');
        setCourseDes('');
        setGrpName('');
        setGroupID('');
        setEditCourseName('');
        setEditCourseDes('');
        setEditGroupID('');
        setEditGrpName('');
        setEditId('');
    }

    // Handle course click
    const handleCourseClick = (courseId) => {
        setCourseIdForChart(courseId)
    };

    return (
        <Box className='fullHW' px={{ xs: 2, md: 6 }} py={{ xs: 2, md: 4 }} display="flex" flexDirection="column">
            <Typography variant="h5" fontWeight={600} mb={{ xs: 1, md: 0 }}>{lngsltd["List of Courses"]}</Typography>

            <ToastContainer
                position="top-center"
                autoClose={2000}
                newestOnTop={false}
                closeOnClick
                progressClassName='custom-toast-progress-bar'

            />

            <InnerContent >
                <FilteringBlock
                    userRole={userRole}
                    handleShowAdd={handleShowAdd}
                    lngsltd={lngsltd}
                    search={search}
                    setSearch={setSearch}
                    handleClearFilters={handleClearFilters}
                />

                <Box mt={2} flexGrow={1} overflow="hidden" width="100%">
                    <CoursesTableWrapper
                        lngsltd={lngsltd}
                        userRole={userRole}
                        data={data}
                        filteredData={filteredData}
                        handleCourseClick={handleCourseClick}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        handleDetails={handleDetails}
                        handleReport={handleReport}
                        buttonRef={buttonRef}
                        handleStart={handleStart}
                        userid={userDetails.userID}
                        userfname={userDetails.firstName}
                        userlname={userDetails.lastName}                        
                    />
                </Box>

                <UpdateCourseDialog
                    show={show}
                    handleClose={handleClose}
                    lngsltd={lngsltd}
                    editCourseName={editCourseName}
                    setEditCourseName={setEditCourseName}
                    editCourseNameError={editCourseNameError}
                    editCourseDes={editCourseDes}
                    setEditCourseDes={setEditCourseDes}
                    editGrpName={editGrpName}
                    setEditGrpName={setEditGrpName}
                    groupData={groupData}
                    editGrpNameError={editGrpNameError}
                    handleUpdate={handleUpdate}
                />

                <AddCourseModal
                    showadd={showadd}
                    handleCloseAdd={handleCloseAdd}
                    lngsltd={lngsltd}
                    coursename={coursename}
                    handleCourseNameChange={handleCourseNameChange}
                    courseNameError={courseNameError}
                    coursedes={coursedes}
                    setCourseDes={setCourseDes}
                    grpName={grpName}
                    setGrpName={setGrpName}
                    groupData={groupData}
                    grpNameError={grpNameError}
                    handleSave={handleSave}
                />

                <CourseChartModal courseid={courseIdForChart} open={!!courseIdForChart} onClose={() => setCourseIdForChart(null)} />

            </InnerContent>

        </Box>
    )

}

export default Courses